import { render } from "./MiniWizardManagerImplicitEditMode.vue?vue&type=template&id=64d04e72"
import script from "./MiniWizardManagerImplicitEditMode.vue?vue&type=script&lang=js"
export * from "./MiniWizardManagerImplicitEditMode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__